export enum PaymentValidationStatusEnum {
    PaymentAuthorized = "PAYMENT_AUTHORISED",
    PaymentInProgress = "PAYMENT_IN_PROGRESS",
    PaymentGotToken = "PAYMENT_GOT_TOKEN",
    PaymentCancelledOverbooking = "PAYMENT_CANCELLED_OVERBOOKING",
}